import { Link } from "react-router-dom";

export const Logo = ({ className = "", onClick }) => (
  <Link
    to="/"
    onClick={onClick}
    data-testid="logo-link"
    className={`inline-flex items-center gap-2.5 group ${className}`}
  >
    <span className="relative flex h-8 w-8 items-center justify-center rounded-sm border border-[#D4AF37]/40 text-[#D4AF37]">
      <span className="font-serif text-lg leading-none">S</span>
      <span className="absolute -bottom-1 -right-1 h-2 w-2 rounded-full bg-[#D4AF37]" />
    </span>
    <span className="font-serif text-xl tracking-tight text-white">
      SelfBook<span className="text-[#D4AF37]"> Italia</span>
    </span>
  </Link>
);
